module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/334.c71ae032.png";